/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {divideBySpaces} from 'helpers/numberHelpers';

import {LastCheckType, SensorGroupsType} from '../types';
import {mapSensorGroupCollection} from './mapSensorGroupCollection';
import {getSubRows} from './getSubRows';
import {getPerCampaignFound} from './getPerCampaignFound';

/**
 * Вернёт кумулятивные данные по срабатываниям сенсоров в группах для этой строки.
 * @param checks
 * @param groups
 * @param campaignId
 */

const mapSensorGroups = (
  checks: ReadonlyArray<LastCheckType>,
  groups: SensorGroupsType,
  campaignId?: string,
): TanStackTableData => {
  const {red, gray, yellow} = groups;

  const checksRed = checks.filter(check => {
    return red.includes(check.sensor.name);
  });

  const checksYellow = checks.filter(check => {
    return yellow.includes(check.sensor.name);
  });

  const checksGray = checks.filter(check => {
    return gray.includes(check.sensor.name);
  });

  const getFound = (check: LastCheckType) =>
    campaignId ? getPerCampaignFound(check, campaignId) : check.found;

  const redTotalNew = checksRed.reduce((acc, cur) => acc + getFound(cur), 0);
  const yellowTotalNew = checksYellow.reduce((acc, cur) => acc + getFound(cur), 0);
  const grayTotalNew = checksGray.reduce((acc, cur) => acc + getFound(cur), 0);

  const redCollection = mapSensorGroupCollection(checksRed, campaignId);
  const yellowCollection = mapSensorGroupCollection(checksYellow, campaignId);
  const grayCollection = mapSensorGroupCollection(checksGray, campaignId);

  const subRows: TanStackTableData[] = getSubRows([
    {collection: redCollection, columnKey: 'red'},
    {collection: yellowCollection, columnKey: 'yellow'},
    {collection: grayCollection, columnKey: 'gray'},
  ]);

  const result: TanStackTableData = {
    red: divideBySpaces(redTotalNew),
    yellow: divideBySpaces(yellowTotalNew),
    gray: divideBySpaces(grayTotalNew),
  };

  if (subRows.length) {
    result.subRows = subRows;
  }

  return result;
};

export {mapSensorGroups};
